import { FormField, Select, Option } from '@sede-enterprise/shell-ds-react-framework';
import React, { Dispatch, SetStateAction } from 'react';

type DispatchType =
  | Dispatch<SetStateAction<string>>
  | Dispatch<SetStateAction<number>>
  | Dispatch<SetStateAction<string[]>>;

interface SelectFormFieldProps {
  id: string;
  label: string;
  testId: string;
  value: string | number | Array<string | number>;
  onChange: DispatchType;
  options: Array<string | number>;
  mode?: 'single' | 'multiple';
  disabled?: boolean;
}

export const PPASelectFormField: React.FC<SelectFormFieldProps> = ({
  id,
  label,
  testId,
  value,
  onChange,
  options,
  mode = 'single',
  disabled = false,
}) => (
  <FormField id={id} label={label} data-testid={testId}>
    <Select
      size='medium'
      allowClear={false}
      aria-label='Select'
      optionLabelProp='label'
      value={value ?? undefined}
      onChange={onChange}
      mode={mode}
      disabled={disabled}
      getPopupContainer={() => document.body} // Render dropdown in portal
      dropdownStyle={{
        zIndex: 1050, // Ensure it's above overlays
        backgroundColor: '#fff',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        borderRadius: '4px',
      }}

    >
      {options.map((val) => (
        <Option key={val} value={val}>
          {val}
        </Option>
      ))}
    </Select>
  </FormField>
);
